import React from 'react';
import { Button, Row, Col, Typography, Card } from 'antd';
import { ClearOutlined, ToolOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const ComandosRapidos = ({
  limpiarCache,
  onRectificarClick,
  rectificarLoading
}) => {
  return (
    <div>
      <Title level={5} style={{ marginBottom: 16, color: '#595959' }}>
        Comandos rápidos
      </Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12}>
          <Card
            hoverable
            onClick={() => !limpiarCache.isLoading && limpiarCache.mutate()}
            style={{
              borderRadius: 12,
              border: '1.5px solid #d9d9d9',
              cursor: limpiarCache.isLoading ? 'not-allowed' : 'pointer',
              textAlign: 'center',
              transition: 'all 0.2s',
            }}
            bodyStyle={{ padding: '24px 16px' }}
          >
            <ClearOutlined style={{ fontSize: 32, color: '#1890ff', marginBottom: 10, display: 'block' }} />
            <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>Limpiar Cache</Text>
            <Text type="secondary" style={{ fontSize: 12 }}>Elimina el cache del sistema</Text>
            <div style={{ marginTop: 16 }}>
              <Button
                type="primary"
                size="small"
                loading={limpiarCache.isLoading}
                onClick={(e) => { e.stopPropagation(); limpiarCache.mutate(); }}
                style={{ borderRadius: 20, minWidth: 90 }}
              >
                Ejecutar
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12}>
          <Card
            hoverable
            onClick={() => !rectificarLoading && onRectificarClick()}
            style={{
              borderRadius: 12,
              border: '1.5px solid #d9d9d9',
              cursor: rectificarLoading ? 'not-allowed' : 'pointer',
              textAlign: 'center',
              transition: 'all 0.2s',
            }}
            bodyStyle={{ padding: '24px 16px' }}
          >
            <ToolOutlined style={{ fontSize: 32, color: '#722ed1', marginBottom: 10, display: 'block' }} />
            <Text strong style={{ fontSize: 15, display: 'block', marginBottom: 4 }}>Rectificar</Text>
            <Text type="secondary" style={{ fontSize: 12 }}>Corrige inconsistencias en BD</Text>
            <div style={{ marginTop: 16 }}>
              <Button
                size="small"
                loading={rectificarLoading}
                onClick={(e) => { e.stopPropagation(); onRectificarClick(); }}
                style={{ borderRadius: 20, minWidth: 90, borderColor: '#722ed1', color: '#722ed1' }}
              >
                Ejecutar
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ComandosRapidos;
